import { Component, OnInit} from '@angular/core';
import { SummaryFetchService } from './summary-fetch.service'
 import { ActivatedRoute,Router } from "@angular/router";

 import { EditSummaryComponent } from './../edit-summary/edit-summary.component';
 import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
 import { MatSnackBar } from '@angular/material/snack-bar';
@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.css']
})
export class SummaryComponent implements OnInit {
  result;
  data;
  isLoaded : Boolean =  false;
  role;
  year;
  siteId
  towerName;
  summary;
  constructor(private snackBar : MatSnackBar,private dialog: MatDialog,private service: SummaryFetchService,private route : ActivatedRoute, private router: Router) {  //,private route: ActivatedRoute
  }

  ngOnInit(): void {
    if (this.router.url.split('/')[1] == "aero-processing") {
      this.role = "aero-processing";
    }
    if (this.router.url.split('/')[1] == "user") {
      this.role = 'user';
    }
    if (this.router.url.split('/')[1] == "pilot") {
      this.role = 'pilot';
    }
    if (this.router.url.split('/')[1] == "super-admin") {
      this.role = 'super-admin';
    }
    if (this.router.url.split('/')[1] == "telstra-processing") {
      this.role = 'telstra-processing';
    }
    this.route.params.subscribe(params =>{
      let tw =params.tower.split('___');      
      this.towerName = tw[0]
      this.siteId= tw[1];
      this.year = params.year;
      if(this.towerName){

        this.service.fetchData(this.towerName, this.siteId, this.year).subscribe((res)=>{
          let temp = res.data();               
          this.data =  temp['Audit']; 
            this.summary = temp['Summary']
        },
        (err)=>{
          this.snackBar.open(err, "close", { duration: 2000 });
        },
        ()=>{
          this.isLoaded = true;
        })


      }
    })
  }
  editEvent(event){
    const dialogRef = this.dialog.open(EditSummaryComponent, {
      width: '450px',
      maxHeight: '850px',
      data: { value: event.value, name: event.field}
    });
    dialogRef.afterClosed().subscribe(
      (result) => {
        this.result = result;
      },
      (err) => {
        this.snackBar.open(err, "close", { duration: 2000 });
      },
      () => {
        this.updateData(event.section,event.field)
      })
  }
  updateData(section,field){
    if(this.summary == undefined || this.summary[section] === undefined){
    this.summary = {}
      let obj = {
        Status : 'N/A',
        Name : 'N/A',
        Comment : 'N/A',
        Date : 'N/A'
      }
      this.summary['SiteApproval'] = obj;
      this.summary['SiteVerification'] = obj;
      console.log(this.summary,section)
    }
    console.log(section,field)
    this.summary[section][field] = this.result;
 this.service.setData(this.towerName, this.siteId,this.year).set({
      Summary : this.summary
 },{
merge : true
 }).catch(err=>{
  this.snackBar.open(err, "close", { duration: 2000 });
 })
  }
}
